import React from 'react'
import PropTypes from 'prop-types'
import ReactGoogleMapLoader from 'react-google-maps-loader'
import ReactGooglePlacesSuggest from 'react-google-places-suggest'
import TextField from 'material-ui/TextField'
import {MenuItem} from 'material-ui/Menu'

class GooglePlacesAutocomplete extends React.Component {

  constructor(props) {
    super(props)

    const initial = this.props.initialValue ? this.props.initialValue : ''

    this.state = {
      search: '',
      value: initial,
    }
  }

  handleInputChange = e => {
    this.setState({search: e.target.value, value: e.target.value})
  }

  handleSelectSuggest = (suggest, handleSelectSuggest) => {
    this.setState({search: '', value: suggest.formatted_address})
    if (handleSelectSuggest) handleSelectSuggest(suggest)
  }

  renderItem = item => (
    <MenuItem component="div">
      {item ? item.description : null}
    </MenuItem>
  )

  render() {
    const {search, value} = this.state
    const {children, apiKey, searchParams, handleSelectSuggest, ...googlePlacesSuggest} = this.props
    return (
      <ReactGoogleMapLoader
        params={{
          key: apiKey,
          libraries: 'places,geocode',
        }}
        render={googleMaps => googleMaps ?
          (
            <ReactGooglePlacesSuggest
              {...googlePlacesSuggest}
              googleMaps={googleMaps}
              autocompletionRequest={{input: search, ...searchParams}}
              onSelectSuggest={suggest => this.handleSelectSuggest(suggest, handleSelectSuggest)}
              customRender={this.renderItem}
            >
              <TextField
                type="text"
                value={value}
                onChange={this.handleInputChange}
                {...this.props.inputProps}
              />
            </ReactGooglePlacesSuggest>
          ) : (
            <TextField
              type="text"
              value={value}
              onChange={this.handleInputChange}
              {...this.props.inputProps}
            />
          )
        }
      />
    )
  }
}

GooglePlacesAutocomplete.propTypes = {
  apiKey: PropTypes.string,
  searchParams: PropTypes.shape({
    offset: PropTypes.number,
    location: PropTypes.string,
    radius: PropTypes.number,
    language: PropTypes.string,
    types: PropTypes.string,
    components: PropTypes.string,
    strictbounds: PropTypes.bool,
  }),
  textNoResults: PropTypes.string,
  handleSelectSuggest: PropTypes.func,
  initialValue: PropTypes.string,
  inputProps: PropTypes.object,
}

export default GooglePlacesAutocomplete



// WEBPACK FOOTER //
// ./src/common/components/GooglePlacesAutocomplete.js